import React from "react";
import { Flex } from "antd";
import DonutProgressChart from "../../Reuseable/DonutProgressChart/DonutProgressChart";
import "./DonutChartWithLegend.scss";
import { formatCurrency } from "../../assets/helpers";
import { useSelector } from "react-redux";

const DonutChartWithLegend = ({
  data = [],
  colors = [],
  width = 175,
  height = 175,
  isPercentage = false
}) => {
  const { format } = useSelector((state) => state.priceFormat);

  return (
    <Flex className="donuts-chart">
      <DonutProgressChart
        data={data}
        colors={colors}
        showCenterLabel={false}
        width={width}
        height={height}
        minAngle={2}
      />

      <div className="donuts-tooltip">
        {data.map((item, index) => (
          <div className="tooltip-item" key={index}>
            <div
              className="color-div"
              style={{ backgroundColor: colors[index] || "#ccc" }}
            ></div>
            <span className="tooltip-label">{item.name} -</span>
            <span className="tooltip-value">{isPercentage ? `${item?.value}%` : formatCurrency(item.value, format)}</span>
          </div>
        ))}
      </div>
    </Flex>
  );
};

export default DonutChartWithLegend;
